import styled, { css } from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const FeedbackWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
    text-align: center;
    width: 100%;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
    margin-bottom: 40px;
    padding: 24px 16px;
    row-gap: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 16px;
    }
    position: relative;
`;

export const FeedbackTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    background-color: ${COLORS.BgSurface};
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const FeedbackButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    column-gap: 16px;
`;

export const FeedbackButton = styled.div<{ clickable: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    width: 124px;
    
    ${({ clickable }) => clickable && css`
        cursor: pointer;
    `}
`;

export const FeedbackEmoticon = styled.div`
    width: 60px;
    height: 60px;
`;

export const FeedbackButtonTitle = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XXS};
    }
`;

export const InputMessage = styled(InputSimple)`
    width: 100%;
    margin-bottom: 0;
`;

export const ButtonMessage = styled(Button)`
    width: 100%;
    margin-top: 12px;
    margin-bottom: 0;
`;

export const StyledThrobber = styled(Throbber)`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(0,0,0,0.1);
    border-radius: ${BorderRadius.OuterBlockRadius};
`;
